export default "__VITE_ASSET__41597b61__"